import { isUrlLike } from './is-url-like';

/**
 * Determines if the provided title resolves to a readable title.
 * Returns false if we should extract a title from the URL instead (no title,
 * title is URL-like, or a file preview).
 */
export const resolvesToReadableTitle = (url: string, title?: string): boolean => {
	if (!title) {
		return false;
	}

	if (isUrlLike(title)) {
		return false;
	}

	try {
		const urlObj = new URL(url);
		return !urlObj.searchParams.has('preview');
	} catch {
		return true;
	}
};
